import { ChangeDetectorRef, Component, OnInit, ViewChild  } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { UserContestService } from 'src/app/services/usercontest.service';
import { QuestionService } from 'src/app/manage/questionanswer/service/question.service';
import { ContestService } from 'src/app/services/contest.service';
import { UserWalletService } from 'src/app/services/userWallet.service';
import * as moment from 'moment';
import { OverlayPanel } from 'primeng/overlaypanel';
@Component({
  selector: 'app-contest-details',
  templateUrl: './contest-details.component.html',
  styleUrls: ['./contest-details.component.scss'],
  providers: [ConfirmationService, MessageService]
})
export class ContestDetailsComponent implements OnInit {
  public loggedInUser: any;
  public isLoggedIn: boolean = false;
  public loginRegisterModal: boolean = false;
  public showMobileLoginOtpForm: boolean = false;
  public userId;
  public termsAndConditionsCheck: boolean = false;
  public dontShowAgainCheck: boolean = false;
  public showTermsAndConditionError: boolean = false;
  public showDontShowAgainError: boolean = false;
  public showSelectedPlayerError: boolean = false;
  public showPlayers: boolean = false;
  public showContestDetailSection: boolean = true;
  public showQuestions: boolean = false;
  public loading: boolean = false;
  public contestId;
  public questionsList: any = [];
  public totalRecords;
  public errorMessage;
  public contestDetails: any = [];
  public playersData: any = [];
  public selectedPlayerName = undefined;
  public userContestId: any;
  public selectedQuestions: any = [];
  public selectedQuestionsTwo: any = [];
  public showQuestionsError: boolean = false;
  public showThankYou: boolean = false;
  public selectedPlayerId;
  public matchId;
  isTplCoinsUsed: boolean;
  totalCoins: any;
  totalDeductedCoin: any;
  tplCoin: number;
  entryCoinsOrCash: any;
  tournamentId: any;
  isContestDoubles: boolean;
  isContestJoin: boolean = false;
  totalCash: any;
  totalDeductedCash: any;
  totalAvailableCash: number;
  totalContestCash: any;
  totalDeductedContestCash: any;
  totalAvailableContestCash: number;
  doOpenContestJoinPaymentPopup: boolean = false;
  isTermsAndConditionsSelected: boolean = false;
  utilizeContestCash: boolean = false;
  utilizeContestCashAmount: any;
  previousAmount: any;
  entryFee: any;
  minimumContestJoinAmountError: boolean = false;
  contestJoinAmountCalculation: string = '';
  isResumeContest: boolean = false;
  questionAnswerDataTwo: any[] = [];
  questionAnswerData: any[] = [];
  updateduserContestId: any;
  minimumCoinsForContestJoinError: boolean = false;
  isMobile: any;
  constructor(
    private formBuilder: FormBuilder,
    private messageService: MessageService,
    private router: Router,
    private tokenStorageService: TokenStorageService,
    private userContestService: UserContestService,
    private questionService: QuestionService,
    private activatedRoute: ActivatedRoute,
    private contestService: ContestService,
    private userWalletService: UserWalletService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
  }
  ngOnInit(): void {
    // this.contestId = this.activatedRoute.snapshot.paramMap.get("contestId");
    this.userContestId = this.activatedRoute.snapshot.paramMap.get("userContestId");
    this.isTplCoinsUsed = (this.activatedRoute.snapshot.queryParamMap.get("tplCoins") === 'true') ? true : false;
    this.isContestJoin = (this.activatedRoute.snapshot.queryParamMap.get("contestJoin") === 'true') ? true : false;
    this.isResumeContest = (this.activatedRoute.snapshot.queryParamMap.get("resumeContest") === 'true') ? true : false;
    this.loggedInUser = this.tokenStorageService.getUser();
    if (this.loggedInUser.userdata != undefined) {
      this.userId = this.loggedInUser.userdata.id;
      this.isLoggedIn = true;
    }
    let query = `filterByDisable=false&filterByStatus=true&filterByUserId=${this.userId}&filterByContestId=${this.userContestId}`;
    if (!this.isContestJoin) {
      if (!this.isResumeContest) {
        // query += `&filterByisContestRegistrationComplete=true`;
      }
    } else {
      this.doOpenContestJoinPaymentPopup = true;
    }
    this.userContestService.getUserContestList(query).subscribe((data) => {
      if (data.data.items.length > 0) {
        this.updateduserContestId = data.data.items[0]?.id;
        if (data.data.items[0]['isContestRegistrationComplete']) {
          let currentUrl = '/contest-history/';
          this.router.routeReuseStrategy.shouldReuseRoute = () => false;
          this.router.onSameUrlNavigation = 'reload';
          this.router.navigate([currentUrl]);
        }

        if (data.data.items[0]?.questionAnswerData.length !== 0 && data.data.items[0]?.questionAnswerDataTwo.length !== 0) {
          this.questionAnswerData = JSON.parse(JSON.stringify(data.data.items[0]?.questionAnswerData));
          this.questionAnswerDataTwo = JSON.parse(JSON.stringify(data.data.items[0]?.questionAnswerDataTwo));
        }
        
        this.utilizeContestCash = data.data.items[0]['utilizeContestCash'];
        const entryFee = data.data.items[0]['entryFee']
        this.utilizeContestCashAmount = (data.data.items[0]['utilizeContestCashAmount'] <= entryFee) ? data.data.items[0]['utilizeContestCashAmount'] : entryFee;
        this.previousAmount = data.data.items[0]['previousAmount'];
        this.entryFee = data.data.items[0]['entryFee'];
      } else {
          this.router.navigate(['contest'], { queryParams: { page: 1, limit: 10}});
          return;
      }
    });
    if (this.isLoggedIn == false) {
      let currentUrl = '/';
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate([currentUrl]);
    }
    this.showThankYou = JSON.parse(window.localStorage.getItem('contest-details-thankyou-page-display'));
    this.router.events.subscribe((events) => {
      if (!this.router.url.includes('/contest-details')) {
        window.localStorage.setItem('contest-details-thankyou-page-display', JSON.stringify(false));
      }
    })
    this.contestId = this.userContestId;
    if (this.isTplCoinsUsed) {
      this.getContestDetails();
    } else {
      this.getUserContest();
    }
    this.loadWalletHistory();
  }
  toggleOverlay(event: Event, overlay: OverlayPanel) {
    this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    if(this.isMobile){
    overlay.toggle(event);
    setTimeout(() => {
      overlay.align();  // Ensure it aligns properly
    }, 50);
  }
  }
  
  getUserContest() {
    this.userContestService.getUserContest(this.userContestId).subscribe(
      async data => {
        this.contestId = data.contestId;
        if(!this.contestId) {
          this.contestId = this.userContestId;
        }
        if (data.isContestRegistrationComplete === true && !this.showThankYou) {
          this.router.navigate(['/contest']);
        }
        if (!this.showThankYou) {
          await this.getContestDetails();
        }
      },
      err => {
      }
    );
  }

  loadWalletHistory() {
    var query = "?filterByDisable=false&filterByUserid=" + this.userId;
    this.userWalletService.getUserWalletList(query).subscribe((data) => {
      this.totalCash = data.data.totalCash;
      this.totalDeductedCash = data.data.totalDeductedCash;
      this.totalAvailableCash = this.totalCash - this.totalDeductedCash;
      this.totalContestCash = data.data.totalContestCash;
      this.totalDeductedContestCash = data.data.totalDeductedContestCash;
      this.totalAvailableContestCash = this.totalContestCash - this.totalDeductedContestCash;
      this.totalCoins = data.data.totalCoins;
      this.totalDeductedCoin = data.data.totalDeductedCoin;
      this.tplCoin = this.totalCoins - this.totalDeductedCoin;
      if (this.utilizeContestCash) {
        this.contestJoinAmountCalculation = "TPL Cash: <i class='bx bx-rupee'></i>"+ (this.entryFee - this.utilizeContestCashAmount) +" <br><span>Contest Cash <i class='bx bx-rupee'></i>"+ this.utilizeContestCashAmount +"</span>";
      } else {
        this.contestJoinAmountCalculation = "TPL Cash: <i class='bx bx-rupee'></i>"+ this.entryFee +"";
      }
    }, (err) => {
      this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Update failed', life: 6000 });
    });
  }

  onTermsAndConditionsSelect(event) {
    if (event.checked) {
      this.termsAndConditionsCheck = true;
    } else {
      this.termsAndConditionsCheck = false;
    }
  }
  onDontShowAgainSelect(event) {
    if (event.checked) {
      this.dontShowAgainCheck = true;
    } else {
      this.dontShowAgainCheck = false;
    }
  }
  async onClickSubmit() {
    if (this.termsAndConditionsCheck == false) {
      this.showTermsAndConditionError = true;
      return;
    } else {
      this.showTermsAndConditionError = false;
    }
    this.showContestDetailSection = false;
    let updatedData = {
      termsAndConditions: this.termsAndConditionsCheck,
      dontShowAgain: this.dontShowAgainCheck
    }
    this.userContestService.updateUserContest(this.userContestId, updatedData).subscribe(
      async data => {
      },
      err => {
      });
  }

  async getContestDetails() {
    this.contestService.getContestDetails(this.userContestId).subscribe(async res => {
      this.contestDetails = res;
      this.isContestDoubles = (this.contestDetails?.player1Name.split('/').length === 2 && this.contestDetails?.player2Name.split('/').length === 2) ? true : false;
      this.entryCoinsOrCash = this.contestDetails?.entryFee;
      this.entryFee = this.entryCoinsOrCash;
      if (!this.utilizeContestCash) {
        this.contestJoinAmountCalculation = "TPL Cash: <i class='bx bx-rupee'></i>"+ this.entryFee +"";
      }
      this.matchId = this.contestDetails.matchId;
      this.tournamentId = this.contestDetails?.tournamentId;
      this.playersData = [
        {
          name: this.contestDetails.player1Name,
          id: this.contestDetails.player1Id,
          playerImage: this.contestDetails.player1Image,
          selected: false
        },
        {
          name: this.contestDetails.player2Name,
          id: this.contestDetails.player2Id,
          playerImage: this.contestDetails.player2Image,
          selected: false
        }
      ];

      let startTime = moment(new Date());
      let end = moment(this.contestDetails?.matchDate);
      let duration = moment.duration(end.diff(startTime));
      let hours = duration.asHours();
      let counter = Number(hours) * Number(3600);
      this.contestDetails["time"] = counter;
      // minute = Math.round(minute);
      this.contestDetails["timerInterval"] = setInterval(() => {
        let seconds = this.contestDetails["time"];
        let dayTime = 60 * 60 * 24;
        let day = Math.floor(seconds / dayTime);
        let remainingTime = seconds - dayTime * day;
        let hoursTime = 60 * 60;
        let hour = Math.floor(remainingTime / hoursTime);
        remainingTime = remainingTime - hoursTime * hour;
        let minTime = 60;
        let minute = Math.floor(remainingTime / minTime);
        remainingTime = remainingTime - minTime * minute;
        let second = Math.floor(remainingTime);
        this.contestDetails["time"]--;
        if (day >= 0) {
          if (day >= 2 && hour >= 0 && minute >= 0 && second >= 0) {
            this.contestDetails["displayTime"] = day + " Days";
          } else if (day > 0 && hour >= 0 && minute >= 0 && second >= 0) {
            this.contestDetails["displayTime"] = day + " Days " + hour + " Hours";
          } else if (day <= 0 && hour > 0 && minute >= 0 && second >= 0) {
            this.contestDetails["displayTime"] =
              hour + " : " + minute + " : " + second + " Hrs";
          } else if (day <= 0 && hour == 0 && minute > 0 && second >= 0) {
            this.contestDetails["displayTime"] =
              minute + " : " + second + " Minutes";
          } else if (day <= 0 && hour == 0 && minute == 0 && second > 0) {
            this.contestDetails["displayTime"] = second + " Seconds left";
          } else if (
            day <= 0 &&
            hour <= 0 &&
            minute <= 0 &&
            second <= 0
          ) {
            this.contestDetails["displayTime"] = "Match Started";
          }
        }
        this.changeDetectorRef.detectChanges();
      }, 1000);
      // this.showPlayers = true;
      this.getQuestionList();
      this.showQuestions = true;
    },
      err => {
        console.log(err);
      });
  }

  contestPlayerName(playerName) {
    if (playerName.split('/').length !== 2) {
      playerName = playerName.split(' ').filter(ele => ele.length > 2)[0];
    } else {
      playerName = playerName.split('/')[0].split(' ')[0]+' & '+playerName.split('/')[1].split(' ')[1];
    }
    return playerName;
  }

  onClickPlayer(player) {
    this.showSelectedPlayerError = false;
    this.selectedPlayerName = player.name;
    this.selectedPlayerId = player.id;
    this.playersData.forEach(element => {

      if (element.name == this.selectedPlayerName) {
        let index = this.findIndexById(element.id, this.playersData);
        if (index != -1) {
          this.playersData[index].selected = true;
        }
      } else {
        let index = this.findIndexById(element.id, this.playersData);
        if (index != -1) {
          this.playersData[index].selected = false;
        }
      }
    });
  }

  getQuestionList() {
    let query = "?filterByDisable=false&filterByStatus=true&filterByContestId=" + this.contestId;
    this.questionService.getQuestionAnswerList(query).subscribe(
      data => {
        this.loading = false;
        this.questionsList = data.data.items.sort((a, b) => a.sequence - b.sequence);
        this.questionsList.forEach(element => {
          element['disable1'] = false;
          element['disable2'] = false;
        });
        this.totalRecords = data.data.totalCount;
        if (this.questionAnswerData.length !== 0 && this.questionAnswerDataTwo.length !== 0) {
          this.questionAnswerData.forEach(ele1 => {
            ele1['id'] = ele1['_id'];
            this.questionsList.find(ele2 => ele2.id === ele1['_id'])['selected1'] = true;
            this.onQuestionSelect(ele1,{ checked: true},'player1');
          });
          this.questionAnswerDataTwo.forEach(ele1 => {
            ele1['id'] = ele1['_id'];
            this.questionsList.find(ele2 => ele2.id === ele1['_id'])['selected2'] = true;
            this.onQuestionSelect(ele1,{ checked: true},'player2');
          });
        }
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }

  onQuestionSelect(question, event, player) {
    if (event.checked) {
      this.questionsList.forEach(element => {
        if (element.id == question.id) {
          let index = this.findIndexById(element.id, this.questionsList);
          if (index != -1) {
            let questionObj = {
              questionId: element.id,
              points: element.points
            }
            if (player === 'player1') {
              this.selectedQuestions.push(questionObj);
            } else {
              this.selectedQuestionsTwo.push(questionObj);
            }
          }
        }
      });

      if (this.selectedQuestions.length === 2 || this.selectedQuestionsTwo.length === 2) {
        this.questionsList.forEach(qElement => {
          let qIndex = this.findIndexByQuestionId(qElement.id, (player === 'player1') ? this.selectedQuestions : this.selectedQuestionsTwo);
          let index = this.findIndexById(qElement.id, this.questionsList);
          if (qIndex != -1) {
            if (index != -1) {
              if (player === 'player1') {
                this.questionsList[index].disable1 = false;
              } else {
                this.questionsList[index].disable2 = false;
              }
            }
          } else {
            if (index != -1) {
              if (player === 'player1') {
                this.questionsList[index].disable1 = true;
              } else {
                this.questionsList[index].disable2 = true;
              }
            }
          }
        });
      }

      if (this.selectedQuestions.length === 2 && this.selectedQuestionsTwo.length === 1) {
        this.questionsList.forEach(qElement => {
          let qIndex1 = this.findIndexByQuestionId(qElement.id, this.selectedQuestions);
          let index1 = this.findIndexById(qElement.id, this.questionsList);
          let qIndex2 = this.findIndexByQuestionId(qElement.id, this.selectedQuestionsTwo);
          let index2 = this.findIndexById(qElement.id, this.questionsList);
          if (qIndex1 != -1) {
            if (index1 != -1) {
              this.questionsList[index1].disable1 = false;
            }
          } else {
            if (index1 != -1) {
              this.questionsList[index1].disable1 = true;
            }
          }
          if (qIndex2 != -1) {
            if (index2 != -1) {
              this.questionsList[index2].disable2 = false;
            }
          } else {
            if (index2 != -1) {
              this.questionsList[index2].disable2 = true;
            }
          }
        });
      }

      if (this.selectedQuestions.length === 1 && this.selectedQuestionsTwo.length === 2) {
        this.questionsList.forEach(qElement => {
          let qIndex1 = this.findIndexByQuestionId(qElement.id, this.selectedQuestions);
          let index1 = this.findIndexById(qElement.id, this.questionsList);
          let qIndex2 = this.findIndexByQuestionId(qElement.id, this.selectedQuestionsTwo);
          let index2 = this.findIndexById(qElement.id, this.questionsList);
          if (qIndex1 != -1) {
            if (index1 != -1) {
              this.questionsList[index1].disable1 = false;
            }
          } else {
            if (index1 != -1) {
              this.questionsList[index1].disable1 = true;
            }
          }
          if (qIndex2 != -1) {
            if (index2 != -1) {
              this.questionsList[index2].disable2 = false;
            }
          } else {
            if (index2 != -1) {
              this.questionsList[index2].disable2 = true;
            }
          }
        });
      }
    } else {
      this.questionsList.forEach(element => {
        if (element.id == question.id) {
          let index = this.findIndexById(element.id, this.questionsList);
          let questionIndex = this.findIndexByQuestionId(element.id, (player === 'player1') ? this.selectedQuestions : this.selectedQuestionsTwo);
          if (questionIndex != -1) {
            if (player === 'player1') {
              this.selectedQuestions.splice(questionIndex, 1);
              this.questionsList[index].disable2 = false;
            } else {
              this.selectedQuestionsTwo.splice(questionIndex, 1);
              this.questionsList[index].disable1 = false;
            }
          }
        }
      });

      if (this.selectedQuestions.length === 1 || this.selectedQuestionsTwo.length === 1) {
        this.questionsList.forEach((qElement, index) => {
          let qIndex1 = this.findIndexByQuestionId(qElement.id, this.selectedQuestions);
          let qIndex2 = this.findIndexByQuestionId(qElement.id, this.selectedQuestionsTwo);
          if (qIndex1 != -1) {
            this.questionsList[index].disable1 = false;
          } else {
            this.questionsList[index].disable1 = true;
          }
          if (qIndex2 != -1) {
            this.questionsList[index].disable2 = false;
          } else {
            this.questionsList[index].disable2 = true;
          }
          if ((qIndex1 === -1 && qIndex2 === -1) || (qIndex1 === -1 && qIndex2 !== -1) || (qIndex1 !== -1 && qIndex2 === -1)) {
            this.questionsList[index].disable1 = false;
            this.questionsList[index].disable2 = false;
          }
        });
      }

      if ((this.selectedQuestions.length === 2 && this.selectedQuestionsTwo.length === 0)) {
        this.questionsList.forEach(qElement => {
          let qIndex = this.findIndexByQuestionId(qElement.id, this.selectedQuestions);
          let index = this.findIndexById(qElement.id, this.questionsList);
          if (qIndex != -1) {
            this.questionsList[index].disable1 = false;
            this.questionsList[index].disable2 = false;
          } else {
            this.questionsList[index].disable1 = true;
            this.questionsList[index].disable2 = false;
          }
        });
      }

      if ((this.selectedQuestions.length === 0 && this.selectedQuestionsTwo.length === 2)) {
        this.questionsList.forEach(qElement => {
          let qIndex = this.findIndexByQuestionId(qElement.id, this.selectedQuestionsTwo);
          let index = this.findIndexById(qElement.id, this.questionsList);
          if (qIndex != -1) {
            this.questionsList[index].disable2 = false;
            this.questionsList[index].disable1 = false;
          } else {
            this.questionsList[index].disable2 = true;
            this.questionsList[index].disable1 = false;
          }
        });
      }
    }

    if ((this.selectedQuestions.length === 2 && this.selectedQuestionsTwo.length === 1) || (this.selectedQuestions.length === 1 && this.selectedQuestionsTwo.length === 2)) {
      this.showQuestionsError = false;
    }
  }

  onClickQuestionSubmit() {
    if ((this.selectedQuestions.length === 2 && this.selectedQuestionsTwo.length === 1) || (this.selectedQuestions.length === 1 && this.selectedQuestionsTwo.length === 2)) {
      this.showQuestionsError = false;
    } else {
      this.showQuestionsError = true;
      return;
    }
    this.onClickLetsPlay();
  }

  findIndexById(id, arrayName) {
    let index = -1;
    for (let i = 0; i < arrayName.length; i++) {
      if (arrayName[i].id === id) {
        index = i;
        break;
      }
    }
    return index;
  }
  findIndexByQuestionId(id, arrayName) {
    let index = -1;
    for (let i = 0; i < arrayName.length; i++) {
      if (arrayName[i].questionId === id) {
        index = i;
        break;
      }
    }
    return index;
  }
  onClickPlayerNext() {
    // if (this.selectedPlayerName == undefined) {
    //   this.showSelectedPlayerError = true;
    //   return;
    // } else {
    //   this.showSelectedPlayerError = false;
    // }
    let updatedData = {
      // playerName: this.selectedPlayerName,
      // playerId: this.selectedPlayerId,
      matchId: this.matchId
    }
    this.userContestService.updateUserContest(this.userContestId, updatedData).subscribe(
      async data => {
        this.showPlayers = false;
        this.getQuestionList();
        this.showQuestions = true;
      },
      err => {
      });
  }
  onClickPlayerpreviwe() {
    this.showPlayers = true;
    this.showQuestions = false;
  }
  onClickViewLeaderBoard(contestId) {
    let currentUrl = '/contest-leader-board/' + contestId;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }
  encodeStr(str: string): string {
    return str.replace(/\//g, '<span class="class-slash">/</span>');
  }

  onClickViewContest() {
    let currentUrl = '/contest-history/';
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }


  onClickLetsPlay() {
    if (this.isTplCoinsUsed) {
      let cash = 0;
      let coins = 0;
      let amount = 0;
      let mode;
      coins = this.entryCoinsOrCash;
      amount = coins;
      mode = "COINS";

      if (this.entryFee > this.tplCoin) {
        this.minimumCoinsForContestJoinError = true;
        return;
      }

      let userWalletData = {
        contestId: this.contestId,
        tournamentId: this.tournamentId,
        userId: this.userId,
        amount: amount,
        wallettype: mode,
        action: "SUBTRACT",
        status: true,
        description: "Contest Joined",
      };
      this.userWalletService.addUserWallet(userWalletData).subscribe(
        async (data) => {
          // await this.addContest(cash, coins);
        this.updateuserContest(this.updateduserContestId);
        },
        (err) => {
          this.messageService.add({
            key: "toastmsg",
            severity: "error",
            summary: "Error",
            detail: "Server error, please try again.",
            life: 6000,
          });
        }
      );
    } else {
      let cash = 0;
      let coins = 0;
      cash = this.entryCoinsOrCash;
      // if (this.isResumeContest) {
      //   this.updateuserContest(this.updateduserContestId);
      // } else {
      //   this.addContest(cash, coins);
      // }
      this.updateuserContest(this.updateduserContestId);
    }
  }

  async addContest(cash, coins) {
    let userContestData = {
      cash: cash,
      coins: coins,
      contestId: this.contestId,
      userId: this.userId,
      tournamentId: this.tournamentId,
      termsAndConditions: this.termsAndConditionsCheck,
      dontShowAgain: this.dontShowAgainCheck,
    };
    this.userContestService.addUserContest(userContestData).subscribe(
      (data) => {
        this.messageService.add({
          key: "toastmsg",
          severity: "success",
          summary: "Successful",
          detail: "Contest Joined Successfully!!",
          life: 6000,
        });
        this.updateuserContest(data._id);
      },
      (err) => { }
    );
  }

  updateuserContest(contestId) {
    window.localStorage.setItem('contest-details-thankyou-page-display', JSON.stringify(false));

    let updatedData = {
      selectedQuestions: this.selectedQuestions,
      selectedQuestionsTwo: this.selectedQuestionsTwo,
      playerName: this.contestDetails?.player1Name,
      playerId: this.contestDetails?.player1Id,
      matchId: this.matchId,
      playerNameTwo: this.contestDetails?.player2Name,
      playerIdTwo: this.contestDetails?.player2Id
    }

    if (this.isResumeContest) {
      updatedData['utilizeContestCash'] = this.utilizeContestCash;
      updatedData['utilizeContestCashAmount'] = this.utilizeContestCashAmount;
      updatedData['previousAmount'] = this.previousAmount;
    }

    this.userContestService.updateUserContest(contestId, updatedData).subscribe(
      async data => {
        if (this.isTplCoinsUsed) {
          this.messageService.add({
            key: "toastmsg",
            severity: "success",
            summary: "Successful",
            detail: "Contest Joined Successfully!!",
            life: 6000,
          });
          setTimeout(()=> {
            this.onClickViewLeaderBoard(data.data.contestId);
          },500);
        } else {
          if (this.totalAvailableCash >= this.entryFee && this.totalAvailableContestCash === 0) {
            this.doOpenContestJoinPaymentPopup = true;
          } else {
            this.navigateToContestPaymentPage();
          }
        }
      },
      err => {
      });
  }

  navigateToContestPaymentPage() {
    window.localStorage.setItem('contest-details-thankyou-page-display',JSON.stringify(false));
    if (this.totalAvailableCash >= this.entryFee && this.totalAvailableContestCash === 0) {
      this.doOpenContestJoinPaymentPopup = false;
    } else {
      setTimeout(() => {
        let currentUrl = "/contest-payment-page/" + this.userContestId + "/" + this.userId;
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = "reload";
        setTimeout(() => {
          if (this.isResumeContest) {
            this.router.navigate([currentUrl], { queryParams : { resumeContest : true }});
          } else {
            this.router.navigate([currentUrl]);
          }
        }, 200);
      }, 200);
    }
  }

  naviagetToContestList() {
    if (this.isResumeContest) {
      let contestHistoryPaginationValues = { page: 1, limit: 10, tab: 1 }
      window.localStorage.setItem('my-contest-pagination',JSON.stringify(contestHistoryPaginationValues));
      this.router.navigate(['/contest-history']);
    } else {
      this.router.navigate(['/contest']);
    }
  }

  joinNowContestCashContest() {
    if(this.utilizeContestCash) {
      if ((this.entryFee - this.utilizeContestCashAmount) > this.totalAvailableCash) {
        this.minimumContestJoinAmountError = true;
        return;
      } else {
        this.minimumContestJoinAmountError = false;
      }
    } else {
      if (this.entryFee > this.totalAvailableCash) {
        this.minimumContestJoinAmountError = true;
        return;
      } else {
        this.minimumContestJoinAmountError = false;
      }
    }

    let addContestJoiningAmountData = {
      contestId: this.contestId,
      tournamentId: this.tournamentId,
      userId: this.userId,
      amount: (this.utilizeContestCash) ? this.entryFee - this.utilizeContestCashAmount : this.entryFee,
      wallettype: "CASH",
      action: "SUBTRACT",
      status: true,
      description: "Contest Joined",
      utilizeCash: true,
    }

    if (this.utilizeContestCash) {
      addContestJoiningAmountData['utilizeContestCash'] = true;
      addContestJoiningAmountData['utilizeContestCashAmount'] = this.utilizeContestCashAmount;
    }

    this.userWalletService.addUserWallet(addContestJoiningAmountData).subscribe(
      async (data) => {
        this.messageService.add({
          key: "toastmsg",
          severity: "success",
          summary: "Successful",
          detail: "Contest Joined Successfully!!",
          life: 6000,
        });
        setTimeout(()=> {
          this.onClickViewLeaderBoard(this.contestId);
        },500);
      },(err) => {
        this.messageService.add({ key: "toastmsg", severity: "error", summary: err.error.message, detail: "Server error, please try again.", life: 6000 });
      }
    );
  }

}
